import React, { Component } from "react";
import { Row, Col, Form, Card, Button, Spin, message } from "antd";
import "antd/dist/antd.min.css";
import AppConfig from "../config/AppConfig";
import { getQuestion } from "../../Api/Apis";
import { Link } from "react-router-dom";

export default class Leadscontact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      loading: true,
    };
  }

  componentDidMount = async () => {
  try {
    const stateData = this.props.location?.state;

    if (stateData && stateData.id) {
      // console.log("Using data from route state:", stateData);
      this.setState({
        companies: [stateData],
        loading: false,
      });
      return;
    }

    const questionnaireId = this.props.match?.params?.id;
    if (!questionnaireId) {
      message.error("Questionnaire id missing.");
      this.setState({ companies: [], loading: false });
      return;
    }

    const res = await getQuestion(
      AppConfig.entityNames.questionnaires,
      questionnaireId
    );

    const raw = res?.data?.data || res?.data;
    const list = Array.isArray(raw) ? raw : [raw];

    this.setState({
      companies: list,
      loading: false,
    });
  } catch (e) {
    console.error("Error loading lead details:", e);
    message.error("Something went wrong while loading details.");
    this.setState({ companies: [], loading: false });
  }
};


  render() {
    const { companies, loading } = this.state;
    const routeLeadId = JSON.parse(localStorage.getItem("leadId"));

    const blurredStyle = {
      filter: "blur(6px)",
      pointerEvents: "none",
      userSelect: "none",
    };
    const overlayStyle = {
      position: "absolute",
      top: 12,
      left: 12,
      right: 12,
      textAlign: "center",
      color: "#fff",
      fontWeight: 600,
      background: "rgba(0,0,0,0.55)",
      padding: "6px 10px",
      borderRadius: 8,
      zIndex: 2,
      fontSize: 12,
    };
    const cardContentWrapper = { position: "relative", minHeight: 120 };

    if (loading) {
      return (
        <div style={{ marginTop: "6vw", textAlign: "center" }}>
          <Spin size="large" />
        </div>
      );
    }

    if (!companies || companies.length === 0) {
      return (
        <div>
          <Row style={{ marginTop: "3vw" }}>
            <Col span={24}>
              <div style={{ textAlign: "center", marginTop: "100px" }}>
                <h1 style={{ fontWeight: "bold" }}>
                  Here are the company details based on your search criteria
                </h1>
                <p style={{ color: "#666" }}>No details were found for this lead.</p>
              </div>
            </Col>

            <Col span={8} offset={8} style={{ marginTop: 40 }}>
              <Link to="/app/Myleads">
                <Button
                  type="primary"
                  style={{
                    borderRadius: "50px",
                    backgroundColor: "#165874",
                    width: "200px",
                    marginLeft: "12vw",
                  }}
                >
                  Go back to My Leads
                </Button>
              </Link>
            </Col>
          </Row>
        </div>
      );
    }

    return (
      <div>
        <Row style={{ marginTop: "3vw" }}>
          <Form style={{ marginBottom: "10%" }}>
            <Col span={24}>
              <div style={{ textAlign: "center", marginTop: "40px" }}>
                <h1 style={{ fontWeight: "bold" }}>
                  Here are the company details based on your search criteria
                </h1>
              </div>
            </Col>

            {companies.map((data) => {
              const purchased =
                data &&
                data.paymentIds &&
                Array.isArray(data.paymentIds) &&
                routeLeadId &&
                data.paymentIds.includes(routeLeadId);

              return (
                <Col span={20} offset={2} key={data.id} style={{ marginTop: 20 }}>
                  <Card
                    className="ant-card-body"
                    style={{
                      marginBottom: "2vw",
                      borderRadius: "10px",
                    }}
                  >
                    <Row>
                      <Col
                        xxl={{ span: 10, offset: 2 }}
                        xl={{ span: 10, offset: 2 }}
                        lg={{ span: 10, offset: 2 }}
                        md={{ span: 10, offset: 2 }}
                        sm={{ span: 24 }}
                        xs={{ span: 24 }}
                      >
                        <span style={{ fontSize: "18px" }}>
                          <b>Company</b>
                        </span>
                        <Row>
                          <h4>{data.businessName}</h4>
                        </Row>

                        <div style={{ marginTop: 8 }}>
                          <span style={{ fontSize: "12px", color: "#777" }}>Industry</span>
                          <div style={{ fontWeight: 600 }}>
                            {Array.isArray(data.industry) ? data.industry.join(", ") : data.industry || "—"}
                          </div>
                        </div>

                        <div style={{ marginTop: 8 }}>
                          <span style={{ fontSize: "12px", color: "#777" }}>Budget</span>
                          <div style={{ fontWeight: 600 }}>{data.rangeGoals || "—"}</div>
                        </div>

                        {data.description ? (
                          <div style={{ marginTop: 8 }}>
                            <span style={{ fontSize: "12px", color: "#777" }}>Why matched</span>
                            <div>{data.description}</div>
                          </div>
                        ) : null}
                      </Col>
                      <Col
                        xxl={{ span: 11, offset: 1 }}
                        xl={{ span: 11, offset: 1 }}
                        lg={{ span: 12 }}
                        md={{ span: 12 }}
                        sm={{ span: 24 }}
                        xs={{ span: 24 }}
                      >
                        <span style={{ fontSize: "18px" }}>
                          <b>Contact Person Details</b>
                        </span>
                        <div style={cardContentWrapper}>
                          {!purchased && <div style={overlayStyle}>Contact details hidden — payment to view</div>}

                          <div style={purchased ? {} : blurredStyle}>
                            <Row style={{ marginTop: 10 }}>
                              <Col span={24}>
                                <div style={{ fontWeight: 600 }}>{data.contactPerson || "—"}</div>
                              </Col>
                            </Row>

                            <Row style={{ marginTop: 8 }}>
                              <Col span={24}>
                                <div>{data.phoneNumber || "—"}</div>
                              </Col>
                            </Row>

                            <Row style={{ marginTop: 8 }}>
                              <Col span={24}>
                                <div>{data.email || "—"}</div>
                              </Col>
                            </Row>

                            <Row style={{ marginTop: 10 }}>
                              <Col>
                                {Array.isArray(data.area) &&
                                  data.area.map((area, idx) => (
                                    <Button
                                      key={idx}
                                      size="small"
                                      style={{
                                        marginRight: 6,
                                        marginBottom: 6,
                                        border: "none",
                                        borderRadius: 12,
                                      }}
                                    >
                                      {area}
                                    </Button>
                                  ))}
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <Row style={{ marginTop: 20 }}>
                      <Col span={24} style={{ textAlign: "center" }}>
                        {!purchased ? (
                          <div style={{ color: "#888", fontSize: 14 }}>
                          Complete payment to unlock contact details
                        </div>
                        ) : (
                          <>
                            <Button
                              onClick={() => {
                                // open telephone link if phone exists
                                if (data.phoneNumber) {
                                  window.location.href = `tel:${data.phoneNumber}`;
                                } else {
                                  message.info("Phone number not available");
                                }
                              }}
                              style={{
                                marginRight: 8,
                                borderRadius: "50px",
                                width: "170px",
                              }}
                            >
                              Call Company
                            </Button>

                            <Button
                              onClick={() => {
                                if (data.email) {
                                  window.location.href = `mailto:${data.email}`;
                                } else {
                                  message.info("Email not available");
                                }
                              }}
                              style={{
                                borderRadius: "50px",
                                width: "170px",
                                marginLeft: 8,
                              }}
                            >
                              Email Company
                            </Button>
                          </>
                        )}
                      </Col>
                    </Row>
                  </Card>
                </Col>
              );
            })}

            <Col span={8} offset={10}>
              <Link to="/app/Myleads">
                <Button
                  key="1"
                  type="primary"
                  style={{
                    borderRadius: "50px",
                    backgroundColor: "#165874",
                    width: "200px",
                    justifyContent: "center",
                  }}
                >
                  Go back to My Leads
                </Button>
              </Link>
            </Col>
          </Form>
        </Row>
      </div>
    );
  }
}
